module.exports = __webpack_public_path__ + "img/user_cancel_failed.ce7dc4d2.png";